import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useAccount, State } from '@grandvisionhq/auth';
import { Context } from '@grandvisionhq/carts-v2';
import { useFeatureToggles } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import '@grandvisionhq/utils';
import '../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '../../mappers/errors-mapping.js';
import '../../utils/get-customer-details-payload.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';
import '@grandvisionhq/payments';
import '../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../operations/mutations/set-customer-details.js';
import '../../operations/mutations/set-service-store.js';
import '../../operations/mutations/set-shipping-method.js';
import '../../operations/mutations/set-shipping-state.js';
import '../../operations/mutations/create-apple-pay-session.js';
import '../../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import { useFetchUserDetails } from '../../hooks/user/use-fetch-user-details.js';
import { useAuthToken } from '../../hooks/user/useAuthToken.js';

const useUserStateConfig = ()=>{
    const { loadUserDetails , loading: isLoadingUserData , userData , error  } = useFetchUserDetails();
    const { cart  } = Context.useCart();
    const { shippingFormFields  } = useCheckoutSettings();
    const prepareInitialFormValues = (formFields)=>formFields.reduce((field, currField)=>swcHelpers.objectSpread({}, field, {
                [currField]: ''
            })
        , {})
    ;
    const invoiceDetails = (shippingFormFields === null || shippingFormFields === void 0 ? void 0 : shippingFormFields.invoice) && (shippingFormFields === null || shippingFormFields === void 0 ? void 0 : shippingFormFields.invoice.length) ? prepareInitialFormValues(shippingFormFields === null || shippingFormFields === void 0 ? void 0 : shippingFormFields.invoice) : undefined;
    const companyDetails = (shippingFormFields === null || shippingFormFields === void 0 ? void 0 : shippingFormFields.company) && (shippingFormFields === null || shippingFormFields === void 0 ? void 0 : shippingFormFields.company.length) ? prepareInitialFormValues(shippingFormFields.company) : undefined;
    const { isMyAccountEnabled  } = useFeatureToggles();
    const authState = useAccount();
    const [, authTokenState] = useAuthToken();
    const authToken = authTokenState.data;
    const isLoggedIn = isMyAccountEnabled && authState === State.AuthState.LoggedIn && Boolean(authToken);
    const formatFormFields = React.useCallback((formData, formName)=>{
        return Object.entries(formData).reduce((item, [key, value])=>{
            if ((shippingFormFields === null || shippingFormFields === void 0 ? void 0 : shippingFormFields[formName]) && (shippingFormFields === null || shippingFormFields === void 0 ? void 0 : shippingFormFields[formName].includes(key))) {
                return swcHelpers.objectSpread({}, item, {
                    [key]: value
                });
            }
            return swcHelpers.objectSpread({}, item);
        }, {});
    }, [
        shippingFormFields
    ]);
    const handleUserDetails = React.useCallback(()=>{
        authToken && loadUserDetails(authToken);
    }, [
        loadUserDetails,
        authToken
    ]);
    const shippingAddressOnCart = React.useMemo(()=>{
        return (cart === null || cart === void 0 ? void 0 : cart.shippingAddress) ? Object.entries(cart.shippingAddress).reduce((item, [key, value])=>swcHelpers.objectSpread({}, item, {
                [key]: value
            })
        , {}) : undefined;
    }, [
        cart === null || cart === void 0 ? void 0 : cart.shippingAddress
    ]);
    React.useEffect(()=>{
        if (isLoggedIn) {
            handleUserDetails();
        }
    // to avoid unneccesary re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn
    ]);
    var ref;
    const billingAddress = React.useMemo(()=>{
        return (ref = shippingAddressOnCart !== null && shippingAddressOnCart !== void 0 ? shippingAddressOnCart : userData === null || userData === void 0 ? void 0 : userData.billingAddress) !== null && ref !== void 0 ? ref : undefined;
    }, [
        shippingAddressOnCart,
        userData === null || userData === void 0 ? void 0 : userData.billingAddress
    ]);
    return React.useMemo(()=>{
        return {
            areUserDetailsLoading: isLoadingUserData,
            isAddressesEqual: false,
            billingAddress: billingAddress ? formatFormFields(billingAddress, 'billingAddress') : undefined,
            contactDetails: (userData === null || userData === void 0 ? void 0 : userData.contactDetails) ? formatFormFields(userData === null || userData === void 0 ? void 0 : userData.contactDetails, 'contactDetails') : undefined,
            invoiceDetails: invoiceDetails !== null && invoiceDetails !== void 0 ? invoiceDetails : undefined,
            companyDetails,
            globalStoreId: userData === null || userData === void 0 ? void 0 : userData.globalStoreId,
            error: Boolean(error),
            isUserLoggedIn: isLoggedIn
        };
    }, [
        isLoadingUserData,
        billingAddress,
        formatFormFields,
        userData === null || userData === void 0 ? void 0 : userData.contactDetails,
        userData === null || userData === void 0 ? void 0 : userData.globalStoreId,
        invoiceDetails,
        companyDetails,
        error,
        isLoggedIn, 
    ]);
};

export { useUserStateConfig };
//# sourceMappingURL=useUserStateConfig.js.map
